import { render, staticRenderFns } from "./LienKetNganHangSHBForm.vue?vue&type=template&id=613c75f2&scoped=true&"
import script from "./LienKetNganHangSHBForm.vue?vue&type=script&lang=js&"
export * from "./LienKetNganHangSHBForm.vue?vue&type=script&lang=js&"
import style0 from "./LienKetNganHangSHBForm.vue?vue&type=style&index=0&id=613c75f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613c75f2",
  null
  
)

export default component.exports